export const LAYOUT_SIDEBAR_SHOW = '[LAYOUT]_SIDEBAR_SHOW'
export const LAYOUT_ASIDE_SHOW = '[LAYOUT]_ASIDE_SHOW'
export const LAYOUT_DARKMODE = '[LAYOUT]_DARKMODE'

export const LAYOUT_SET_NEW_BREADCRUMB = '[LAYOUT]_SET_NEW_BREADCRUMB'
export const LAYOUT_APPEND_BREADCRUMB = '[LAYOUT]_APPEND_BREADCRUMB'
